import { Box, Button, useToast, VStack } from "@chakra-ui/react";
import { useAddMobileMoneyAccountMutation } from "apis";
import { InputLabel, Input, Select } from "components";
import { useAuthToken } from "hooks";
import { ICreateMobileMoneyDto } from "interfaces";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setNewTransferId } from "store/slices";

interface IProps {
  fiatType?: string;
  hideCountry?: boolean;
  changeTab?: (index: number) => void;
}
const AddMobileMoney = ({ fiatType, hideCountry, changeTab }: IProps) => {
  const { authToken } = useAuthToken();
  const toast = useToast();
  const [_addFiatAccount, { isLoading }] = useAddMobileMoneyAccountMutation();

  const defaultCountry = useMemo(() => {
    const mapCountry: any = {
      kes: "ke",
      ghs: "gh",
    };

    const fiat = fiatType?.toLowerCase() ?? "ghs";

    return mapCountry[fiat] as string;
  }, [fiatType]);

  console.log(defaultCountry, "DEFAULT COUNTRY");

  const operatorName = useMemo(() => {
    const country: any = {
      kes: ["MPesa"],
      ghs: ["MOMO", "Vodafone", "AirtelTigo"],
      ngn: [""],
    };

    const fiat = fiatType?.toLowerCase() ?? "ghs";
    return country[fiat] as string[];
  }, [fiatType]);

  const [state, setState] = useState<ICreateMobileMoneyDto>({
    accountName: "",
    country: defaultCountry,
    institutionName: "",
    mobile: "",
    operator: operatorName[0],
    token: "",
  });

  useEffect(() => {
    if (defaultCountry) {
      setState({
        ...state,
        country: defaultCountry,
        operator: operatorName[0],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCountry, operatorName]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { value, name } = e.target;

    setState({
      ...state,
      [name]: value,
    });
  };

  const dispatch = useDispatch();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { accountName, mobile, operator, country } = state;
    try {
      const response = await _addFiatAccount({
        accountName,
        country,
        mobile,
        operator: operator.toLowerCase() === "momo" ? "mtn" : operator.toUpperCase(),
        institutionName: operator,
        token: authToken!,
      }).unwrap();

      if (response?.fiatAccountId) {
        dispatch(setNewTransferId(response.fiatAccountId));
        toast({
          position: "bottom-right",
          title: "Success",
          description: "Account added successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        changeTab && changeTab(1);
      }
    } catch (error) {}
  };

  const isDisabled = useMemo(() => {
    return !state.accountName || !state.mobile || !state.operator;
  }, [state]);

  return (
    <Box>
      <Box mt="16px">
        <form onSubmit={handleSubmit}>
          <VStack spacing="24px">
            {!hideCountry && (
              <Box width="100%">
                <InputLabel htmlFor="country">Country</InputLabel>
                <Select id="country" name="country" onChange={handleChange} isDisabled defaultChecked defaultValue={defaultCountry}>
                  <option value="ke">Kenya</option>
                  <option value="gh">Ghana</option>
                </Select>
              </Box>
            )}

            <Box width="100%">
              <InputLabel htmlFor="accountName">Account Name</InputLabel>

              <Input
                onChange={handleChange}
                isRequired
                type="text"
                id="accountName"
                name="accountName"
                placeholder="Account Name"
              />
            </Box>

            <Box width="100%">
              <InputLabel htmlFor="operator">Network Type</InputLabel>

              <Select
                id="operator"
                name="operator"
                onChange={handleChange}
                defaultChecked
                defaultValue={fiatType === "kes" ? operatorName[0] : ""}
              >
                {operatorName?.map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </Select>
            </Box>

            <Box width="100%">
              <InputLabel htmlFor="mobile">Phone Number</InputLabel>
              <Input onChange={handleChange} isRequired type="text" id="mobile" name="mobile" placeholder="Phone Number" />
            </Box>
          </VStack>

          <Button
            mt="42px"
            width="100%"
            type="submit"
            minW={{ base: "auto", "2sm": "400px" }}
            isDisabled={isDisabled}
            isLoading={isLoading}
          >
            Submit
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default AddMobileMoney;
